import isEmpty from '../../utils/isEmpty';
import validate from '../mixins/validate';
import getLocaleMixins from '../../utils/getLocaleMixins';

const name = 'setting-password';

/*
说明：设置 - 内容页(修改密码)
功能：
    1. 修改密码
*/
export default {
    name,
    data() {
        return {
            busy: false,
            oldPassword: null,
            newPassword: null,
            confirmPassword: null,
        };
    },
    computed: {
        disabled() {
            return isEmpty(this.oldPassword)
                || isEmpty(this.newPassword)
                || isEmpty(this.confirmPassword);
        },
    },
    mixins: [
        validate(),
        getLocaleMixins(name),
    ],
    methods: {
        submit() {
            const context = this;
            if (!context.valid() || context.busy) {
                return;
            }
            const userApi = this.$im().dataModel.User;
            const params = {
                newPassword: context.newPassword,
                oldPassword: context.oldPassword,
            };
            if (context.newPassword === context.oldPassword) {
                context.$set(context.errors, 'newPassword', context.locale.errorCode['new-password-same-old-password']);
                return;
            }
            context.busy = true;
            // 2019-06-12 密码加密传输 userApi.changePassword 改为 securityChangePassword
            userApi.securityChangePassword(params, (errorCode) => {
                context.busy = false;
                if (errorCode) {
                    let errDes = this.RongIM.common.getErrorMessage(errorCode);
                    // 同一个错误码 在设置密码时 提示信息不一样
                    if (errorCode === 10101) {
                        errDes = context.locale.errorCode['old-password-error'];
                    }
                    context.$set(context.errors, 'oldPassword', errDes);
                }
            });
        },
    },
};
